import { graphql } from '@/gql';
import liff from '@line/liff';
import LIFFInspectorPlugin from '@line/liff-inspector';

// Workaround: liff.initをpageで呼ぶとvue-routerと競合してパラメータが消えるため、pluginで呼ぶ

const PluginQuery = graphql(`
  query liffPlugin($providerId: ID!) {
    lineActivationProviderLiffAppConfigByProviderId(providerId: $providerId) {
      clientId
      liffId
    }
  }
`);

export default defineNuxtPlugin(
  async ({
    vueApp,
    $config: {
      public: { liffDebugOrigin },
    },
  }) => {
    const currentRoute = vueApp.$nuxt.$router.currentRoute.value;
    if (!currentRoute.path.startsWith('/providers/')) {
      // プロバイダーが特定できないページではLIFFを初期化しない
      return;
    }

    if (liffDebugOrigin) {
      console.log('LIFFInspectorPlugin enabled', liffDebugOrigin);
      liff.use(new LIFFInspectorPlugin({ origin: liffDebugOrigin }));
    }

    const providerId = getStringQuery(
      currentRoute.params.lineActivationProviderId
    );
    if (!providerId) {
      throw new Error('providerId is required');
    }

    const { data } = await vueApp.$nuxt.$urql.value.query(PluginQuery, {
      providerId,
    });

    if (!data || !data.lineActivationProviderLiffAppConfigByProviderId) {
      throw new Error('failed to init LIFF App');
    }

    await liff.init({
      liffId: data.lineActivationProviderLiffAppConfigByProviderId.liffId,
    });
  }
);
